import { HR_EMPLOYEES_ME } from './employeeEndpoints'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { EmployeeProfileDto } from '@/modules/User/types/api/employee'

export function fetchEmployeeMe(): Promise<EmployeeProfileDto> {
  return axiosInstance
    .get<EmployeeProfileDto>(HR_EMPLOYEES_ME)
    .then((response) => response.data)
}
